import React from 'react';
import {Checkbox, Form, Icon, Input, Radio, Select} from 'antd';
import Signature from "./Signature";
import SignatureTrimmed from "./SignatureTrimmed";
import { withNamespaces } from 'react-i18next';

const { Option } = Select;

class ConsentMevoStep3aRegainedCapacity extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;
    const site_001 = '001';
    const site_025 = '025';
    const site_026 = '026';
    const site_030 = '030';
    const site_27 = '027';
    const site_40 = '040';

    const isEmail = props.consentMethodType && props.consentMethodType.includes("Email"); // is also true if consent electronic
    const isAfterDeferral = props.consentMethodType.includes('AfterDeferral');
    const isSurrogate = props.consentPersonType === "Surrogate";
    const showForEmail = !(isEmail && !props.token);
    const isSubjectFirst = props.email_consent_signature_order === "subject_first";

    let preNameOfParticipant = '';
    let NameOfParticipant = 'Name of Participant';
    let SignatureOfParticipant = 'Signature of Participant';
    let NameofPersonObtainingConsent = 'Name of Person Obtaining Consent';
    let SignatureOfPersonObtainingConsent = 'Signature of Person Obtaining Consent';

    if ([site_025, site_026, site_030].includes(props.site_code)) {
      preNameOfParticipant = 'Your signature documents your consent to take part in this research';

      NameOfParticipant = 'Printed Name of adult subject capable of consent';
      SignatureOfParticipant = 'Signature of adult subject capable of consent';

      NameofPersonObtainingConsent = 'Printed Name of Person Obtaining Consent';
      SignatureOfPersonObtainingConsent = 'Signature of Person Obtaining Consent';
    }

    if ([site_27].includes(props.site_code)) {
      NameOfParticipant = 'Printed Name of Participant';
      NameofPersonObtainingConsent = 'Printed Name of Person Obtaining Consent';
      SignatureOfPersonObtainingConsent = 'Signature of Person Obtaining Consent';
    }

    if ([site_40].includes(props.site_code)) {
      // preNameOfParticipant = 'Your signature documents your consent to take part in this research';
      NameOfParticipant = 'Name of Participant';
      SignatureOfParticipant = 'Signature of Participant';
      NameofPersonObtainingConsent = 'Name of Person Obtaining Consent';
      SignatureOfPersonObtainingConsent = 'Signature of Person Obtaining Consent';
    }


    return (
      <div className="form-group consent-form-ui">
        <style>
          {".consent-form-ui h1, h2, h3, h4, h5, h6 {text-transform: none;}"}
        </style>
        <div className="form-group-details">
          <h4>{this.props.i18n.t('NamespaceConsentStep3aRegainedCapacity:Consent Process - REGAINED CAPACITY CONSENT FORM')}</h4>

          {props.siteID && <h5>{this.props.i18n.t('Site ID')}: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>{this.props.i18n.t('User ID')}: <b>{props.userID}</b></h5>}
          <h5>{this.props.i18n.t('Subject ID')}: <b>{props.subjectID}</b></h5>
        </div>

        {isAfterDeferral && <div>
        {props.randomization_platform_step_3_regained_capacity_after_deferral_content ? <div
            dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_regained_capacity_after_deferral_content}}/> : <h4 align="center">
          Template not loaded
          <br/>
          <br/>
        </h4>
        }
        </div>}

        {!isAfterDeferral && <div>
        {props.randomization_platform_step_3_patient_regained_capacity_content ? <div
            dangerouslySetInnerHTML={{__html: props.randomization_platform_step_3_patient_regained_capacity_content}}/> : <h4 align="center">
          Template not loaded
          <br/>
          <br/>
        </h4>
        }
        </div>}

        <p><strong>{this.props.i18n.t('Server Date (UTC)')}: {props.consentDate || props.date}</strong></p>
        <p><strong>{this.props.i18n.t('Consent Type')}: {props.consentPersonType}</strong></p>
        <p><strong>{this.props.i18n.t('Consent Method')}: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <div style={{ textAlign: 'left' }}>
          {![site_025, site_026, site_030, site_27, site_40].includes(props.site_code) && <div>{showForEmail && <div>
            <Form.Item>
              <label>
                <div className='form-label'>{this.props.i18n.t('NamespaceConsentStep3aRegainedCapacity:Please check the appropriate box to indicate your decision')}:</div>
                {props.form.getFieldDecorator('rccf_option', {
                  initialValue: props.rccf_option,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value='stay_in_study'>
                      {this.props.i18n.t('NamespaceConsentStep3aRegainedCapacity:I wish to stay in the study.')}
                    </Radio>
                    <br/>
                    <Radio value='withdraw_from_study'>
                      {this.props.i18n.t('NamespaceConsentStep3aRegainedCapacity:I wish to withdraw from the study')}
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

            <Form.Item>
              <label>
                <div className='form-label' style={{ fontWeight: 'semibold', fontSize: '16px' }}>
                  WHAT IF RESEARCHERS DISCOVER SOMETHING ABOUT ME?
                </div>
                <div>
                  During the study, the researchers could learn something about you that they didn’t expect. For example, the researchers may find out that you have another medical condition. The researchers will consult with medical experts as needed to evaluate the findings and will then share these results with you. You will be helped with arranging appropriate follow up and care.
                </div>
                <div className='form-label' style={{ margin: '5px 0' }}>I consent for the researchers to share findings with me:</div>
                {props.form.getFieldDecorator('consent_question_rccf_researchers_share_findings_with_me', {
                  initialValue: props.consent_question_rccf_researchers_share_findings_with_me,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value={true}>
                      Yes
                    </Radio>
                    <br/>
                    <Radio value={false}>
                      No
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
            <Form.Item>
              <label>
                <div className='form-label' style={{ fontWeight: 'semibold', fontSize: '16px' }}>
                  USE OF DATA FOR FUTURE RESEARCH
                </div>
                <div className='form-label' style={{ margin: '5px 0' }}>My research data may be kept for use in future research to learn about, prevent or treat other health-related problems.</div>
                {props.form.getFieldDecorator('consent_question_rccf_use_my_research_data', {
                  initialValue: props.consent_question_rccf_use_my_research_data,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value={true}>
                      Yes
                    </Radio>
                    <br/>
                    <Radio value={false}>
                      No
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>
            <Form.Item>
              <label>
                <div className='form-label' style={{ margin: '5px 0' }}>Additional blood/urine may be taken for this research, as described in the consent form.</div>
                {props.form.getFieldDecorator('consent_question_rccf_may_take_additional_samples', {
                  initialValue: props.consent_question_rccf_may_take_additional_samples,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value={true}>
                      Yes
                    </Radio>
                    <br/>
                    <Radio value={false}>
                      No
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

            <Form.Item>
              <label>
                <div className='form-label' style={{ fontWeight: 'semibold', fontSize: '16px' }}>
                  CONTACT FOR FUTURE RESEARCH
                </div>
                <div className='form-label' style={{ margin: '5px 0' }}>University of Calgary researchers may contact me in the future to ask me to take part in other research studies.</div>
                {props.form.getFieldDecorator('consent_question_rccf_future_contact', {
                  initialValue: props.consent_question_rccf_future_contact,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value={true}>
                      Yes
                    </Radio>
                    <br/>
                    <Radio value={false}>
                      No
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

            <div>
              <h5>WHO CAN I CONTACT IF I HAVE QUESTIONS ABOUT THIS STUDY?</h5>
              <b>The Research Team:</b>
              <p>You may contact Dr. Andrew Demchuk at 403 944 8671 with any questions or concerns about the research or your participation in this study.</p>

              <b>Conjoint Health Research Ethics Board (CHREB):</b>
              <p>If you have any questions concerning your rights as a possible participant in this research, please contact the Chair, Conjoint Health Research Ethics Board, University of Calgary at 403-220-7990.</p>
              <br/>
              <h5>HOW CAN I FIND OUT ABOUT THE STUDY RESULTS?</h5>
              <p>ClinicalTrials.gov is a website that provides information about federally and privately supported clinical trials. A description of this clinical trial will be available on <a href="http://www.clinicaltrials.gov">http://www.ClinicalTrials.gov</a>. This website will not include information that can identify you. At most, the website will include a summary of the results. You can search this website at any time.</p>
              <br/>

              <h5>WHAT ARE MY RIGHTS IF I TAKE PART IN THIS STUDY?</h5>
              <p>Taking part in this study is your choice. You can choose whether or not you want to participate. Whatever decision you make, there will be no penalty to you.</p>
              • You have a right to have all of your questions answered before deciding whether to take part. <br/>
              • Your decision will not affect the standard medical care you receive<br/>
              • If you decide to take part, you can leave the study at any time.<br/><br/>

              <h5>HOW DO I INDICATE MY AGREEMENT TO PARTICIPATE?</h5>
              <p>Your signature on this form indicates that you have understood to your satisfaction the information regarding your participation in the research project and agree to continue your participation in the study. In no way does this waive your legal rights nor release the investigators or involved institutions from their legal and professional responsibilities.</p>
              <br/>
            </div>
          </div>}</div>}

          {showForEmail && [site_40].includes(props.site_code) && <div>
            <Form.Item>
              <label>

                <div className='form-label'><b>CONSENT TO CONTACT YOUR FAMILY DOCTOR:</b></div>
                {props.form.getFieldDecorator('consent_question_rccf_contact_my_family_doctor', {
                  initialValue: props.consent_question_rccf_contact_my_family_doctor,
                  rules: [{
                    required: true,
                    message: 'Required'
                  }],
                })(
                  <Radio.Group disabled={props.signature_type === "investigator"}>
                    <Radio value={true}>
                      Yes, I consent for my family doctor to be informed of my participation.
                    </Radio>
                    <br/>
                    <Radio value={false}>
                      No, I do not consent for my family doctor to be informed of my participation.
                    </Radio>
                  </Radio.Group>
                )}
              </label>
            </Form.Item>

            <div>
              <div>PCP/ Healthcare Provider:</div>
              <br/>
              <Form.Item>
                <label>
                  <div className="form-label">
                    Name
                  </div>
                  {props.form.getFieldDecorator("extra_field_healthcare_provider_name", {
                    initialValue: props.extra_field_healthcare_provider_name,
                    rules: [
                      {
                        required: false,
                        message: "Required",
                      },
                    ],
                  })(
                    <Input placeholder='Name' disabled={props.signature_type === "investigator"}/>
                  )}
                </label>
              </Form.Item>
              <Form.Item>
                <label>
                  <div className="form-label">
                    Address
                  </div>
                  {props.form.getFieldDecorator("extra_field_healthcare_provider_address", {
                    initialValue: props.extra_field_healthcare_provider_address,
                    rules: [
                      {
                        required: false,
                        message: "Required",
                      },
                    ],
                  })(
                    <Input placeholder='Address' disabled={props.signature_type === "investigator"}/>
                  )}
                </label>
              </Form.Item>
              <Form.Item>
                <label>
                  <div className="form-label">
                    City/State/Zip
                  </div>
                  {props.form.getFieldDecorator("extra_field_healthcare_provider_city_state_zip", {
                    initialValue: props.extra_field_healthcare_provider_city_state_zip,
                    rules: [
                      {
                        required: false,
                        message: "Required",
                      },
                    ],
                  })(
                    <Input placeholder='City/State/Zip' disabled={props.signature_type === "investigator"}/>
                  )}
                </label>
              </Form.Item>
              <Form.Item>
                <label>
                  <div className="form-label">
                    Phone and Fax numbers
                  </div>
                  {props.form.getFieldDecorator("extra_field_healthcare_provider_contact_numbers", {
                    initialValue: props.extra_field_healthcare_provider_contact_numbers,
                    rules: [
                      {
                        required: false,
                        message: "Required",
                      },
                    ],
                  })(
                    <Input placeholder='Phone and Fax numbers' disabled={props.signature_type === "investigator"}/>
                  )}
                </label>
              </Form.Item>
            </div>
          </div>}

          {([site_40].includes(props.site_code) && (!isEmail || showForEmail)) && <div><br/><Form.Item>
            <label>
              <div className="form-label">
                <b>{this.props.i18n.t(
                  "NamespaceConsentStep3aPatient:Please check the appropriate box to indicate your decision"
                )}:</b>
              </div>
              {props.form.getFieldDecorator("rccf_option", {
                initialValue: props.rccf_option,
                rules: [
                  {
                    required: true,
                    message: "Required",
                  },
                ],
              })(
                <Radio.Group
                  disabled={props.signature_type === "investigator"}
                >
                  <Radio value="stay_in_study">
                    {this.props.i18n.t(
                      "NamespaceConsentStep3aPatient:I wish to stay in the study."
                    )}
                  </Radio>
                  <br />
                  <Radio value="withdraw_from_study">
                    {this.props.i18n.t(
                      "NamespaceConsentStep3aPatient:I wish to withdraw from the study"
                    )}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item><br/></div>}


          {![site_27].includes(props.site_code) && <h5>SIGNATURE OF STUDY PARTICIPANT</h5>}
          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t(NameOfParticipant)}</div>
              {props.form.getFieldDecorator('rccf_subject_full_name', {
                initialValue: props.rccf_subject_full_name,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Input
                  prefix={<Icon type="user" style={{color: '#000'}}/>}
                  placeholder={NameOfParticipant}
                />
              )}
            </label>
          </Form.Item>

          {!isEmail && <div>
            <Form.Item>
              {props.form.getFieldDecorator("email_consent_copy_to_subject", {
                initialValue: false,
                valuePropName: "checked",
              })(
                <Checkbox>
                  {this.props.i18n.t(
                    "NamespaceConsentStep3aPatient:Send copy of consent via email"
                  )}
                </Checkbox>
              )}
            </Form.Item>

            {props.form.getFieldValue("email_consent_copy_to_subject") && <div>
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      "NamespaceConsentStep3aPatient:Patient Email"
                    )}
                  </div>
                  {props.form.getFieldDecorator("consent_subject_email", {
                    initialValue: props.consent_subject_email,
                    rules: [
                      {
                        required: true,
                        message: this.props.i18n.t(
                          "NamespaceConsentStep3aPatient:Please enter the participant's email"
                        ),
                      },
                      { type: "email" },
                    ],
                  })(
                    <Input
                      disabled={props.token}
                      placeholder={this.props.i18n.t("email")}
                    />
                  )}
                </label>
              </Form.Item>
            </div>}
          </div>}

          {isEmail && <Form.Item>
            {props.form.getFieldDecorator('rccf_subject_email', {
              initialValue: props.rccf_subject_email,
              rules: [{required: true, message: this.props.i18n.t('NamespaceConsentStep3aRegainedCapacity:Please enter the participant\'s email')}, {type: 'email'}],
            })(
              <Input disabled={props.token} placeholder="email"/>
            )}
          </Form.Item>}

          {props.signature_type === "investigator" && props.rccf_subject_signature && <img src={props.rccf_subject_signature} width={250} alt='Subject Signature' />}

          {props.consentPersonType === 'Patient' && showForEmail && (isSubjectFirst && isEmail
            ? props.signature_type === "participant"
            : true) && (
            <div>
              <Signature fieldName='rccf_subject_signature' label={this.props.i18n.t(`NamespaceConsentStep3aRegainedCapacity:${SignatureOfParticipant}`)} form={props.form} />
            </div>
          )}

          <div>

            {props.site_code !== site_025 && <div>
              {[site_40].includes(props.site_code) && <h5><b>SIGNATURE OF PERSON OBTAINING CONSENT</b></h5>}

              <Form.Item>
                <label>
                  <div className='form-label'>{this.props.i18n.t(`NamespaceConsentStep3aRegainedCapacity:${NameofPersonObtainingConsent}`)}</div>
                  {props.form.getFieldDecorator('rccf_investigator_full_name', {
                    initialValue: props.rccf_investigator_full_name,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      disabled={props.token}
                      prefix={<Icon type="user" style={{color: '#000'}}/>}
                      placeholder={this.props.i18n.t(`NamespaceConsentStep3aRegainedCapacity:${NameofPersonObtainingConsent}`)}
                    />
                  )}
                </label>
              </Form.Item>
            </div>}
            {props.site_code === site_025 && <div>
              <Form.Item>
                <label>
                  <div className='form-label'>{this.props.i18n.t(`NamespaceConsentStep3aRegainedCapacity:${NameofPersonObtainingConsent}`)}</div>
                  {props.form.getFieldDecorator('rccf_consent_obtainer_full_name', {
                    initialValue: props.rccf_consent_obtainer_full_name,
                    rules: [{
                      required: true,
                      message: 'Required'
                    }],
                  })(
                    <Input
                      disabled={props.token}
                      prefix={<Icon type="user" style={{color: '#000'}}/>}
                      placeholder={this.props.i18n.t(`NamespaceConsentStep3aRegainedCapacity:${NameofPersonObtainingConsent}`)}
                    />
                  )}
                </label>
              </Form.Item>
            </div>}


            {![site_025, site_026, site_030].includes(props.site_code) && <div><Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t(
                    "NamespaceConsentStep3aPatient:Person Obtaining Consent Contact Number"
                  )}
                </div>
                {props.form.getFieldDecorator(
                  "rccf_investigator_contact_number",
                  {
                    initialValue: props.rccf_investigator_contact_number || ([site_001].includes(props.site_code) ? "4039442863" : ""),
                    rules: [
                      {
                        required: true,
                        message: "Required",
                      },
                    ],
                  }
                )(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t(
                      "NamespaceConsentStep3aPatient:Person obtaining consent contact number"
                    )}
                  />
                )}
              </label>
            </Form.Item></div>}

            {props.site_code !== site_025 && <div>

              {((!props.token && !isSubjectFirst) ||
                props.signature_type === "investigator" || !isEmail) && <Signature fieldName='rccf_investigator_signature' label={this.props.i18n.t(`NamespaceConsentStep3aRegainedCapacity:${SignatureOfPersonObtainingConsent}`)} form={props.form} />}
            </div>}

            {props.site_code === site_025 && <div>

              {((!props.token && !isSubjectFirst) ||
                props.signature_type === "investigator" || !isEmail) && <Signature fieldName='rccf_consent_obtainer_signature' label={this.props.i18n.t(`NamespaceConsentStep3aRegainedCapacity:${SignatureOfPersonObtainingConsent}`)} form={props.form} />}
            </div>}

          </div>

          {isEmail && isSubjectFirst && !props.signature_type && (
            <Form.Item>
              <label>
                <div className="form-label">
                  {this.props.i18n.t("Person Obtaining Consent Email")}
                </div>
                {props.form.getFieldDecorator("consent_investigator_email", {
                  initialValue: props.consent_investigator_email,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t(
                        "NamespaceConsentStep3aPatient:Please enter the person's obtaining consent email"
                      ),
                    },
                    { type: "email" },
                  ],
                })(
                  <Input
                    disabled={props.token}
                    placeholder={this.props.i18n.t("email")}
                  />
                )}
              </label>
            </Form.Item>
          )}


          <div>
            {!isEmail && ![site_025, site_026, site_030, site_27].includes(props.site_code) && (
              <div>
                {[site_40].includes(props.site_code) && <div>
                  <h5><b>SIGNATURE OF THE WITNESS</b></h5>
                  <div>
                    Used in cases where the participant or LAR is illiterate, or the short form consent process is
                    needed.
                    <br/>
                    <br/>
                  </div>
                </div>}

                <Form.Item>
                  <label>
                    <div className="form-label">
                      {this.props.i18n.t(
                        "NamespaceConsentStep3aPatient:Witness Name (if applicable)"
                      )}
                    </div>
                    {props.form.getFieldDecorator(
                      "rccf_witness_full_name",
                      {
                        initialValue: props.rccf_witness_full_name,
                      }
                    )(
                      <Input
                        prefix={
                          <Icon type="user" style={{ color: "#000" }} />
                        }
                        placeholder={this.props.i18n.t(
                          "NamespaceConsentStep3aPatient:Witness Name (if applicable)"
                        )}
                      />
                    )}
                  </label>
                </Form.Item>

                <Signature
                  fieldName="rccf_witness_signature"
                  label="Signature of Witness (if applicable)"
                  form={props.form}
                  optional={true}
                />
              </div>
            )}
          </div>

          {[site_026, site_030].includes(props.site_code) && <div>
            {props.consentPersonType === 'Patient' && showForEmail && (isSubjectFirst && isEmail
              ? props.signature_type === "participant"
              : true) && (
              <div>
                <h5>Authorization:</h5>
                <p>I have been given the information about the use and disclosure of my health information for this research study. My questions have been answered.</p>
                <p>I authorize the use and disclosure of my health information to the parties listed in the authorization section of this consent for the purposes described above.</p>

                <h5 style={{ margin: '15px 0', textDecoration: 'underline' }}>AUTHORIZATION SIGNATURE</h5>
                <Signature
                  fieldName="subject_authorization_signature"
                  label={this.props.i18n.t(
                    `NamespaceConsentStep3aPatient:Signature of Subject`
                  )}
                  form={props.form}
                />
              </div>
            )}
          </div>}


          {props.site_code === site_025 && <div>
            <div>
              <h5>CERTIFICATE OF INVESTIGATOR</h5>
              <p style={{ marginBottom: '15px' }}>I certify that this subject has been consented</p>
              <Form.Item>
                <label>
                  <div className="form-label">
                    {this.props.i18n.t(
                      `NamespaceConsentStep3aPatient:Printed Name of Investigator`
                    )}
                  </div>
                  {props.form.getFieldDecorator(
                    "rccf_investigator_full_name",
                    {
                      initialValue: props.rccf_investigator_full_name,
                      rules: [
                        {
                          required: true,
                          message: "Required",
                        },
                      ],
                    }
                  )(
                    <Input
                      disabled={props.token}
                      prefix={<Icon type="user" style={{ color: "#000" }} />}
                      placeholder={this.props.i18n.t(
                        `NamespaceConsentStep3aPatient:Printed Name of Investigator`
                      )}
                    />
                  )}
                </label>
              </Form.Item>
            </div>

            {(!isEmail ? true : (isSubjectFirst ? props.signature_type === "investigator" : !props.token)) && (
              <Signature
                fieldName="rccf_investigator_signature"
                label={this.props.i18n.t(
                  `NamespaceConsentStep3aPatient:Signature of Investigator`
                )}
                form={props.form}
              />
            )}
          </div>}



          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentStep3aRegainedCapacity:Please CONFIRM that the data entered above is correct and complete!')}</div>
              {props.form.getFieldDecorator('consent_provided', {
                initialValue: props.consent_provided,
                rules: [{
                  required: true,
                  message: this.props.i18n.t('NamespaceConsentStep3aRegainedCapacity:Please CONFIRM that the data entered above is correct and complete!')
                }],
              })(
                <Select>
                  <Option value="yes">{this.props.i18n.t('Yes')}</Option>
                  <Option value="">{this.props.i18n.t('No')}</Option>
                </Select>
              )}
            </label>
          </Form.Item>

        </div>
      </div>
    );
  }
}

export default withNamespaces()(ConsentMevoStep3aRegainedCapacity)



// WEBPACK FOOTER //
// ./src/components/ConsentTypeMevo/ConsentMevoStep3aRegainedCapacity.js